








import { Component, Vue } from 'vue-property-decorator';
import MunicipalitySelectionForm from '@/components/Municipality/MunicipalitySelectionForm.vue';
import MunicipalitySelectionList from '@/components/Municipality/MunicipalitySelectionList.vue';

@Component({
  components: {
    MunicipalitySelectionForm,
    MunicipalitySelectionList,
  },
})
export default class Municipalities extends Vue {}
